import { Dispatch } from '@reduxjs/toolkit';
import { zooluxCallCenterAPI } from '../../../zooluxCallCenterAPI';
import { ICategory } from '../../repository/ICategory';
import { AnyAction } from 'redux-saga';

const categoryAPI = zooluxCallCenterAPI.injectEndpoints({
    endpoints: (builder) => ({
        getOneCategory: builder.query<ICategory, string | undefined>({
            query: (id) => ({
                url: `/category/one/${id}`,
                method: 'GET',
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }: {
                dispatch: Dispatch<AnyAction>,
                queryFulfilled: Promise<{}>,
            }) {
                try { } catch (error) {
                    console.error("Error fetching getOneCategory:", error);
                }
            },
        }),
    }),
    overrideExisting: false,
});

export const { useGetOneCategoryQuery } = categoryAPI;
